<template>
	<div>
		<div class="row">
			<!-- Este perfil é tripulante -->
			<div class="col-xs-3 form-group">
				<label>{{ _traducao('global', 'estePerfilEhTripulante') }} </label>
				<flSimNao v-model="form.tripulante" :value="form.tripulante" />
			</div>

			<!-- O USUÁRIO PODE EDITAR SUAS CONFIGURAÇÕES -->
			<div class="col-xs-4 form-group">
				<label>{{
					_traducao('global', 'oUsuarioPodeAlterarSuasConfigs')
				}}</label>
				<br />
				<div class="btn-group print-button-group" role="group">
					<button
						type="button"
						@click="setaConfig(true)"
						:class="{'btn-info': suasConfig}"
						class="btn btn-default btn-sm"
					>
						{{ _traducao('global', 'sim') }}
					</button>
					<button
						type="button"
						@click="setaConfig(false)"
						:class="{'btn-info': !suasConfig}"
						class="btn btn-default btn-sm"
					>
						{{ _traducao('global', 'nao') }}
					</button>
				</div>
			</div>

			<!-- Carregar automaticamente -->
			<div class="col-xs-5 form-group" v-show="_idCliente == 9">
				<label>{{
					_traducao('global', 'carregaAutomaticoPerfilAoCriarUsuario')
				}}</label>
				<flSimNao v-model="form.padrao" :value="form.padrao" />
			</div>
		</div>
		<!-- PRIVILEGIOS DO SISTEMA -->
		<div class="row">
			<div class="col-xs-12 form-group" style="margin-bottom: 0px">
				<label>{{ _traducao('menuAGnovoUsuario', 'menuAGprivilegio') }}:</label>
			</div>
		</div>
		<!-- LISTA DE MODULOS -->
		<div class="row">
			<div class="col-md-5">
				<div class="list-group">
					<a
						href="#"
						class="list-group-item"
						:class="{'active-privilegio': modulo.selecionada}"
						v-for="(modulo, indexModulo) in modulos"
						@click.prevent="clickExibeAgrupamentoModulos(indexModulo)"
						:key="indexModulo"
					>
						<span>
							<i class="icone-privilegio-grupo" :class="[modulo.icone]"></i>
							{{ modulo.texto }}
						</span>
						<span class="pull-right">
							<i
								class="fa fa-lg fa-arrow-circle-right"
								v-show="modulo.selecionada"
							></i>
						</span>
					</a>
				</div>
			</div>
			<!-- PRIVILEGIOS E SEUS ACESSOS -->
			<div class="col-md-7">
				<!-- ACESSO -->
				<div class="list-group" v-show="acesso != ''">
					<a
						href="#"
						class="list-group-item"
						style="height: 60px"
						:title="acesso.descricao + ' (' + acesso.id + ')'"
						:class="{'active-privilegio': acesso.selecionada}"
						@click.prevent="clickMarcaPrivilegio(acesso)"
					>
						<div class="row">
							<div class="col-xs-11">
								<i class="icone-privilegio" :class="acesso.icone"></i>
								<p style="margin: 0px">{{ acesso.titulo }}</p>
								<small>{{ acesso.descricao }} </small>
							</div>

							<div class="col-xs-1">
								<span class="pull-right">
									<i
										class="fa fa-lg fa-check-circle"
										v-show="acesso.selecionada"
									></i>
									<i
										class="fa fa-lg fa-circle-o"
										v-show="!acesso.selecionada"
									></i>
								</span>
							</div>
						</div>
					</a>
				</div>
				<!-- PRIVILEGIOS -->
				<div class="list-group">
					<div
						style="margin-bottom: 6px"
						v-show="exibeMod && listaFiltradaPrivilegios.length > 1"
					>
						<button @click="addTodos" class="btn btn-success btn-xs">
							<i class="fa fa-check-circle fa-fw"></i
							>{{ _traducao('global', 'todos') }}
						</button>

						<button
							@click="removeTodos"
							class="btn btn-danger pull-right btn-xs"
						>
							<i class="fa fa-times fa-fw"></i
							>{{ _traducao('global', 'todos') }}
						</button>
					</div>

					<div
						v-for="(
							privilegioFiltrado, indexPrivilegioFiltrado
						) in listaFiltradaPrivilegios"
						:key="indexPrivilegioFiltrado"
					>
						<a
							href="#"
							class="list-group-item"
							style="height: 60px"
							:title="
								privilegioFiltrado.descricao +
								' (' +
								privilegioFiltrado.id +
								')'
							"
							:class="{'active-privilegio': privilegioFiltrado.selecionada}"
							v-show="privilegioFiltrado.acesso == 0 && exibeMod"
							v-if="privilegioFiltrado.ativado == '1'"
							@click.prevent="clickMarcaPrivilegio(privilegioFiltrado)"
						>
							<div class="row">
								<div class="col-xs-11">
									<i
										class="icone-privilegio"
										:class="[privilegioFiltrado.icone]"
									></i>
									<p style="margin: 0px">{{ privilegioFiltrado.titulo }}</p>
									<small>{{ privilegioFiltrado.descricao }} </small>
								</div>

								<div class="col-xs-1">
									<span class="pull-right">
										<i
											class="fa fa-lg fa-check-circle"
											v-show="privilegioFiltrado.selecionada"
										></i>
										<i
											class="fa fa-lg fa-circle-o"
											v-show="!privilegioFiltrado.selecionada"
										></i>
									</span>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
			default: {}
		}
	},

	data() {
		return {
			grupos_privilegios: [],
			privilegios: [],
			exibeBtnTodosPrivilegios: false,
			modulos: [],
			mods: [],
			suasConfig: false,
			mod: ''
		}
	},
	computed: {
		acesso() {
			if (this.mod != '') {
				for (let privilegio of this.privilegios) {
					if (
						this.mod &&
						privilegio &&
						this.mod.id_modulo == privilegio.id_modulo &&
						privilegio.acesso == 1
					) {
						return privilegio
						break
					}
				}
			}
			return ''
		},
		exibeMod() {
			if (this.acesso == '') {
				return false
			}
			return this.acesso.selecionada
		},
		listaFiltradaPrivilegios() {
			if (this.mod != '') {
				const listaPrivilegios = []
				for (let privilegio of this.privilegios) {
					if (
						this.mod &&
						privilegio &&
						this.mod.id_modulo == privilegio.id_modulo
					) {
						listaPrivilegios.push(privilegio)
					}
				}
				return listaPrivilegios
			}
			return []
		}
	},
	mounted() {
		this.mods['solicitacao'] = {
			texto: this._traducao('global', 'solicitacao').toUpperCase()
		}
		this.mods['ordem_missao'] = {
			texto: this._traducao('global', 'ordemDeMissao').toUpperCase()
		}
		this.mods['monitoramento'] = {
			texto: this._traducao('global', 'monitoramento').toUpperCase()
		}
		this.mods['rastreamento'] = {
			texto: this._traducao('global', 'rastreamento').toUpperCase()
		}
		this.mods['hfdm'] = {texto: 'FDM'}
		this.mods['manutencao'] = {
			texto: this._traducao('global', 'manutencao').toUpperCase()
		}
		this.mods['relatorios'] = {
			texto: this._traducao('menu', 'menuRelatorios').toUpperCase()
		}
		this.mods['administracao'] = {
			texto: this._traducao('menu', 'administracao').toUpperCase()
		}
		this.mods['administracao_academica'] = {
			texto: this._traducao('global', 'escolaDeVoo').toUpperCase()
		}
		this.mods['notificacao'] = {
			texto: this._traducao('global', 'hNotificacao').toUpperCase()
		}
		this.mods['diario_bordo'] = {
			texto: this._traducao('global', 'diarioDeBordo').toUpperCase()
		}
		this.mods['diario_bordo_mecanico'] = {
			texto: this._traducao('global', 'diarioDeBordoMecanico').toUpperCase()
		}
		this.mods['prevencao_qualificada'] = {
			texto: this._traducao('global', 'prevencaoQualificada').toUpperCase()
		}
		this.mods['mensagem'] = {
			texto: this._traducao('global', 'mensagem').toUpperCase()
		}
		this.mods['despacho_emergencial'] = {
			texto: this._traducao('global', 'despachoDeAeronaves').toUpperCase()
		}
		this.mods['carta_situacao_operacoes'] = {
			texto: this._traducao('global', 'cartaDeSituacaoOperacoes').toUpperCase()
		}
		this.mods['diario_bordo_operador'] = {
			texto: this._traducao('global', 'diarioDeBordoOperador').toUpperCase()
		}
		this.mods['suporte'] = {
			texto: this._traducao('global', 'suporte').toUpperCase()
		}
		this.mods['contrato'] = {
			texto: this._traducao('global', 'contratos').toUpperCase()
		}
		// this.mods['procedimento_operacional_padrao'] = { texto : this._traducao('global','procedimentoOperacionalPadrao').toUpperCase() };
		this.mods['trello'] = {
			texto: this._traducao('global', 'trelloFollowair').toUpperCase()
		}
		this.mods['programacao_voo'] = {
			texto: this._traducao('global', 'programacaoVoo').toUpperCase()
		}
		this.mods['discrepancias'] = {
			texto: this._traducao('global', 'discrepancia1').toUpperCase()
		}
		this.mods['escala'] = {
			texto: this._traducao('submenu', 'escala').toUpperCase()
		}
		this.mods['combustivel'] = {
			texto: this._traducao('global', 'abastecimento').toUpperCase()
		}
		this.mods['documentacao'] = {
			texto: `${this._traducao('global', 'gestaoDe')} ${this._traducao(
				'global',
				'documentos'
			)}`.toUpperCase()
		}
		this.mods['estoque'] = {
			texto: this._traducao('global', 'estoque').toUpperCase()
		}
		this.mods['seguranca_operacional'] = {
			texto: this._traducao('menu', 'segurancaOperacional').toUpperCase()
		}
		this.mods['lei_aeronauta'] = {
			texto: this._traducao('global', 'leiAeronauta').toUpperCase()
		}
		this.mods['licencas_habilitacoes_registros'] = {
			texto: this._traducao(
				'global',
				'licencasHabilitacoesRegistros'
			).toUpperCase()
		}
		this.mods['fiscalizacao_rampa'] = {
			texto: 'FISCALIZAÇÃO DE RAMPA'
		},
		this.mods['despacho_comercial'] = {
			texto: this._traducao('menu', 'despachoComercial').toUpperCase()
		},
		this.mods['gestao_malha_comercial'] = {
			texto: this._traducao('menu', 'gestaoMalhaComercial').toUpperCase()
		}
		this.carregaDados()
	},
	methods: {
		limpa() {
			this.suasConfig = false
			this.grupos_privilegios = this.grupos_privilegios.map(
				(grupoPrivilegio) => {
					grupoPrivilegio.selecionada = false
					return grupoPrivilegio
				}
			)
			this.privilegios = this.privilegios.map((privilegio) => {
				privilegio.selecionada = false
				privilegio.exibir = false
				return privilegio
			})
		},
		marca(privilegiosUsuario) {
			this.suasConfig = false
			this.privilegios = this.privilegios.map((privilegio) => {
				privilegio.selecionada = false
				for (let privilegioUsuario of privilegiosUsuario) {
					if (privilegioUsuario.id == 27) {
						this.suasConfig = true
					}
					if (privilegioUsuario.id == privilegio.id) {
						privilegio.selecionada = true
						break
					}
				}
				privilegio.exibir = false
				return privilegio
			})
		},
		setaConfig(val) {
			this.suasConfig = val
			this.privilegios.forEach((privilegio) => {
				if (privilegio.id == 27) {
					privilegio.selecionada = val
				}
				return privilegio
			})
			this.levantaEvento()
		},
		addTodos() {
			this.listaFiltradaPrivilegios.forEach((privilegio) => {
				if (privilegio.acesso == 0 && this.exibeMod) {
					this.alteraPriv(privilegio.id, true)
				}
			})
			this.levantaEvento()
		},
		removeTodos() {
			this.listaFiltradaPrivilegios.forEach((privilegio) => {
				if (privilegio.acesso == 0 && this.exibeMod) {
					this.alteraPriv(privilegio.id, false)
				}
			})
			this.levantaEvento()
		},
		alteraPriv(id, estado) {
			this.privilegios = this.privilegios.map((privilegio) => {
				if (privilegio.id == id) {
					privilegio.selecionada = estado
				}
				return privilegio
			})
		},
		clickExibeAgrupamentoModulos(index) {
			this.modulos.forEach((modulo) => {
				modulo.selecionada = false
			})
			this.modulos[index].selecionada = true
			this.mod = this.modulos[index]
		},
		levantaEvento() {
			const listaIdPrivilegio = []
			this.privilegios.forEach((privilegio) => {
				if (privilegio.selecionada) {
					listaIdPrivilegio.push({id: Number(privilegio.id)})
				}
			})
			this.$emit('alterou-privilegios', listaIdPrivilegio)
		},
		desmarcaPrivilegios() {
			for (let privilegio of this.privilegios) {
				if (privilegio.id_modulo == this.acesso.id_modulo) {
					privilegio.selecionada = false
				}
			}
		},

		clickMarcaPrivilegio(privilegioFiltrado) {
			for (let privilegio of this.privilegios) {
				if (privilegioFiltrado.id == privilegio.id) {
					privilegio.selecionada = !privilegio.selecionada

					if (!privilegio.selecionada && privilegio.acesso == 1) {
						this.desmarcaPrivilegios()
					}
				}
			}
			this.levantaEvento()
		},
		carregaDados() {
			this._httpGet('/Privilegio/get_privilegio', (retorno) => {
				if (retorno._request) {
					for (let agrupamento of retorno.agrupamento) {
						agrupamento.selecionada = false
					}
					for (let privilegio of retorno.privilegio) {
						privilegio.selecionada = false
						privilegio.exibir = false
					}
					this.grupos_privilegios = retorno.agrupamento
					this.privilegios = retorno.privilegio
				}
			})
			this.modulos = window.$cliente.getVersao().modulo.map((modulo, index) => {
				modulo.texto = this.mods[modulo.descricao]
					? this.mods[modulo.descricao].texto
					: ''
				modulo.selecionada = false
				return modulo
			})
		}
	}
}
</script>